/* tslint:disable:variable-name */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProcessingService {
  constructor() {
  }

  public processingTask: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public processingDataRun: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public processingMultiSign: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public processingMultiSignStatus: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public processingCheckMan: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public processingInputReasonValue: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public processingnewInitialInfoValue: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public processingMultiSignCancel: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public signUpdateStatus: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public recordSocketQueue: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public recordSocketContractQueue: BehaviorSubject<any> = new BehaviorSubject<any>({});
}
